"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProductPageCarousel = void 0;
require("@splidejs/splide/dist/css/splide-core.min.css");
require("@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css");
var splide_1 = __importDefault(require("@splidejs/splide"));
// @ts-expect-error
var splide_extension_video_1 = __importDefault(require("@splidejs/splide-extension-video"));
var vue_1 = require("vue");
exports.ProductPageCarousel = vue_1.defineComponent({
    name: 'ProductPageCarousel',
    setup: function (props) {
        var splideId = vue_1.ref("a" + Math.random().toString(36).substr(2));
        var thumbnailSplideId = vue_1.ref(splideId.value + "-thumbnails");
        vue_1.onMounted(function () {
            var splide = new splide_1["default"]("#" + splideId.value, {
                rewind: true,
                pagination: false,
                autoWidth: false,
                // @ts-ignore
                arrows: false,
                // @ts-ignore
                video: {
                    autoplay: false,
                    // temporary fix, @see https://github.com/Splidejs/splide-extension-video/issues/37
                    loop: true,
                },
            });
            var thumbnailsSplide = new splide_1["default"]("#" + thumbnailSplideId.value, {
                rewind: true,
                autoWidth: true,
                isNavigation: true,
                focus: 'center',
                pagination: false,
                cover: true,
                // @ts-ignore
                arrows: 'slider',
            }).mount();
            splide.sync(thumbnailsSplide).mount({ Video: splide_extension_video_1["default"] });
        });
        return {
            splideId: splideId,
            thumbnailSplideId: thumbnailSplideId,
        };
    },
    template: /* html */ "\n        <div class=\"relative\">\n            <div class=\"splide max-w-full\" :id=\"splideId\">\n                <div class=\"splide__slider\">\n                    <div class=\"splide__track mb-12\">\n                        <slot></slot>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"splide thumbnails\" :id=\"thumbnailSplideId\">\n                <div class=\"splide__slider flex flex-nowrap flex-row justify-center items-center gap-12\">\n                    <div class=\"splide__track\">\n                        <slot name=\"thumbnails\"></slot>\n                    </div>\n\n                    <div class=\"splide__arrows absolute flex items-center justify-between w-11/12 left-0 right-0 mx-auto\">\n                        <button class=\"splide__arrow splide__arrow--prev border-none shadow-none\">\n                            <i class=\"icon-angle-left text-80 text-green\"></i>\n                        </button>\n                        <button class=\"splide__arrow splide__arrow--next border-none shadow-none\">\n                            <i class=\"icon-angle-right text-80 text-green\"></i>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    ",
});
